import { baseOcrRequest } from '../api';

/**
 * 检查用户是否在白名单中
 * @param {Array} whiteList - 白名单键列表
 * @returns {Promise<Object>} 匹配的白名单映射
 */
export const checkIsInWhite = async (whiteList) => {
  const { QCLogin } = window;
  let uin = QCLogin.getUin();
  return new Promise(async (resolve) => {
    try {
      if (QCLogin && !!QCLogin.isLogin()) {
        const res = await baseOcrRequest({
          cmd: 'BatchCheckWhitelist',
          data: {
            WhitelistKeyList: whiteList,
            WhitelistUinList: [uin]
          },
          isExample: false,
          module: 'account',
          checkLogin: false
        });
        if (!res.error) {
          let matchList = res.MatchedWhitelist;
          matchList = Object.fromEntries(matchList.map(item => [item.WhitelistKey, item.WhitelistUinList]));
          resolve(matchList);
        } else {
          resolve({});
        }
      } else {
        resolve({});
      }
    } catch (err) {
      console.log('checkIsInWhite err', err);
      resolve({});
    }
  });
};

/**
 * 检查用户是否已登录
 * @param {Event} e - 事件对象
 * @returns {Promise<boolean>} 是否已登录
 */
export const isLogin = async (e) => {
  const { QCLogin } = window;
  if (QCLogin && !!QCLogin.isLogin()) {
    return true;
  } else {
    e?.stopPropagation();
    QCLogin?.showLoginBox();
    return false;
  }
};
